import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getAcreditaciones = async (filtros = {}) => {
  try {
    const userInfo = fetchUser();
    const params = new URLSearchParams({ empresa: userInfo.empresa, ...filtros });
    const { data } = await Axios.get(`/acreditacion?${params.toString()}`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const upsertAcreditacion = async (payload) => {
  try {
    const { data } = await Axios.post('/acreditacion/upsert', payload);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getAcreditacionByCarpeta = async (idCarpeta) => {
  try {
    const userInfo = fetchUser();
    const { data } = await Axios.get(`/acreditacion?empresa=${userInfo.empresa}&idCarpeta=${idCarpeta}`);
    return data[0] || null;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const syncLogisticaAcreditacion = async (id, documentosLogistica) => {
  try {
    const { data } = await Axios.patch(`/acreditacion/${id}/sync`, { documentosLogistica });
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateAcreditacion = async (id, payload) => {
  try {
    const { data } = await Axios.patch(`/acreditacion/${id}`, payload);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
